// extracted by mini-css-extract-plugin
export default {"maincontainer":"CarInfoPending_maincontainer__wvbxv","form":"CarInfoPending_form__3wO93","loader":"CarInfoPending_loader__PYze8","table":"CarInfoPending_table__IEWnF"};